"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
/**
 * @author Qianhao Dong <qidon@microsoft.com>
 */
const localizeUtils_1 = require("../../../common/localizeUtils");
function localString(key, ...params) {
    return [(0, localizeUtils_1.getDefaultString)(key, ...params), (0, localizeUtils_1.getLocalizedString)(key, ...params)];
}
class Messages {
    static SomethingIsMissing = (something) => localString("plugins.bot.SomethingIsMissing", something);
    static FailToProvisionSomeResource = (resource) => localString("plugins.bot.FailedToProvision", resource);
    static FailToUpdateConfigs = (something) => localString("plugins.bot.FailedToUpdateConfigs", something);
    static BotRegistrationNotFoundWith = (botId) => localString("plugins.bot.BotRegistrationNotFoundWith", botId);
    static BotResourceExist = (where) => (0, localizeUtils_1.getLocalizedString)("plugins.bot.BotResourceExists", where);
    static ProvisioningBotRegistration = (0, localizeUtils_1.getLocalizedString)("plugins.bot.ProvisionBotRegistration");
    static SuccessfullyProvisionedBotRegistration = (0, localizeUtils_1.getLocalizedString)("plugins.bot.ProvisionBotRegistrationSuccess");
    // Suggestions
    static RetryTheCurrentStep = (0, localizeUtils_1.getLocalizedString)("suggestions.retryTheCurrentStep");
    static CheckOutputLogAndTryToFix = (0, localizeUtils_1.getLocalizedString)("plugins.bot.CheckLogAndFix");
    static NotAllowedToAcquireBotFrameworkToken = () => localString("error.appstudio.NotAllowedToAcquireBotFrameworkToken");
    static BotProvisionReturnsForbiddenResult = (error) => {
        const logMessage = (0, localizeUtils_1.getDefaultString)("error.appstudio.BotProvisionReturnsForbiddenResult", JSON.stringify(error.response?.data));
        const displayMessage = (0, localizeUtils_1.getLocalizedString)("error.appstudio.BotProvisionReturnsForbiddenResult");
        return [logMessage, displayMessage];
    };
    static BotProvisionReturnsConflictResult = () => localString("error.appstudio.BotProvisionReturnsConflictResult");
}
exports.Messages = Messages;
//# sourceMappingURL=messages.js.map